import React from "react";
import { ReduxState, ReduxDispatch } from "ducks/reducers";
import { reduxForm, InjectedFormProps } from "redux-form";
import { Grid } from "material-ui";
import { connect } from "react-redux";

import validate from "./NewThreadFormValidator";
import ExtendedField from "components/form/ExtendedField";
import renderTextField from "../../../components/form/RenderTextField";
import renderSelectField from "../../../components/form/RenderSelectField";
import { SubjectCategoryDto } from "util/DTOs/SubjectCategoryDtos";

interface INewThreadFormProps {
    form: string;
    initialValues: any;
    onSubmit: Function;
    onSubmitFail: Function;
    subjectCategories: SubjectCategoryDto[];
}

interface INewThreadFormDispatchProps { }

interface INewThreadFormReduxProps { }

export interface NewThreadFormData {
    subject: string;
    body: string;
    subjectCategoryId: string;
}

type NewThreadFormProps = INewThreadFormProps &
    INewThreadFormDispatchProps &
    INewThreadFormReduxProps &
    InjectedFormProps<
        NewThreadFormData,
        INewThreadFormProps & INewThreadFormReduxProps
    >;

const NewThreadForm: React.SFC<NewThreadFormProps> = (props) => {
    const mainCategories = props.subjectCategories.filter(
        (cat) => !cat.parentCategoryId
    );
    const subCategories = props.subjectCategories.filter(
        (cat) => cat.parentCategoryId
    );
    const onlyMainCategories = !props.subjectCategories.some(
        (cat) => cat.parentCategoryId !== undefined && cat.parentCategoryId > 0
    );

    const options: { header: boolean; label: string; value: string }[] = [];
    mainCategories.forEach((main) => {
        const subs = subCategories.filter(
            (sub) => sub.parentCategoryId === main.id
        );
        if (subs && subs.length > 0) {
            options.push({
                header: true,
                label: main.name,
                value: String(main.id),
            });
            subs.forEach((sub) => {
                options.push({
                    header: false,
                    label: sub.name,
                    value: String(sub.id),
                });
            });
        } else {
            if (!onlyMainCategories) {
                options.push({
                    header: true,
                    label: main.name,
                    value: "dummy" + String(main.id),
                });
            }
            options.push({
                header: false,
                label: main.name,
                value: String(main.id),
            });
        }
    });

    return (
        <Grid container>
            <Grid item xs={12}>
                <ExtendedField
                    component={renderSelectField}
                    name="subjectCategoryId"
                    type="select"
                    placeholder=""
                    label="Asia koskee"
                    required={true}
                    options={options}
                />
            </Grid>
            <Grid item xs={12}>
                <ExtendedField
                    component={renderTextField}
                    name="subject"
                    type="text"
                    label={"Otsikko"}
                    required={true}
                />
            </Grid>
            <Grid item xs={12} style={{ marginTop: 8 }}>
                <ExtendedField
                    component={renderTextField}
                    name="body"
                    type="textarea"
                    rows={4}
                    rowsMax={8}
                    label={"Viesti"}
                    required={true}
                    maxCount={5000}
                />
            </Grid>
        </Grid>
    );
};

const form = reduxForm<
    NewThreadFormData,
    INewThreadFormProps & INewThreadFormReduxProps
>({
    validate,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
})(NewThreadForm);

const mapStateToProps = (state: ReduxState): INewThreadFormReduxProps => {
    return {};
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): INewThreadFormDispatchProps => {
    return {};
};

export default connect<
    INewThreadFormReduxProps,
    INewThreadFormDispatchProps,
    INewThreadFormProps
>(
    mapStateToProps,
    mapDispatchToProps
)(form as any);



// WEBPACK FOOTER //
// ./src/views/messages/components/NewThreadForm.tsx